import Paragraph from "components/typography/Paragraph";
import Link from "components/layout/Link";
import { useTranslation } from "react-i18next";
import formatMessage from "utils/formatMessage";
import { useLocation, useHistory } from "react-router-dom";
import { CardsBlockWrapper } from "components/layout/Card/CardsBlockWrapper";
import { CardWrapper } from "components/layout/Card/CardWrapper";
import Heading from "components/typography/Heading";
import { CardTitle } from "components/layout/Card/CardTitle";
import { CardBody } from "components/layout/Card/CardBody";
import EmptyBlock from "components/layout/Block/BlockEmpty";

const NotFound = ({ staticContext = {} }) => {
	const { t } = useTranslation(["common"]);
	// console.log("staticContext", staticContext);
	if (staticContext) {
		staticContext.notFound = "true";
	}

	const history = useHistory();
	const location = useLocation();
	if (location.pathname !== "/error404") history.push("/error404");

	return (
		<CardsBlockWrapper>
			<CardWrapper>
				<CardTitle>
					<Heading type="h2">
						{t("common:notFound.errorCatch")}
					</Heading>
				</CardTitle>
				<CardBody>
					<Paragraph>{t("common:notFound.pageNotFound")}</Paragraph>
					<Paragraph>
						{formatMessage(t("common:notFound.backToMain"), {
							mainPage: (
								<Link
									underline
									to="/"
									color="primary"
									key="mainPage"
								>
									{t("common:notFound.mainPage")}
								</Link>
							),
						})}
					</Paragraph>
				</CardBody>
			</CardWrapper>
			<EmptyBlock />
		</CardsBlockWrapper>
	);
};

export default NotFound;
